import * as LucideIcons from 'lucide-react';

export function resolveLucideIcon(name, fallback = LucideIcons.Circle) {
  if (!name || typeof name !== 'string') {
    return fallback;
  }

  return LucideIcons[name] || fallback;
}
